import React from 'react';

const RegistrationForm: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 206 164">
      <rect
        width="205.567"
        height="163.654"
        x="0.173"
        y="0.173"
        fill="#fff"
        rx="5.392"
      ></rect>
      <path
        stroke="#A29C95"
        strokeWidth="0.173"
        d="M102.913 148L102.913 17"
      ></path>
      <rect
        width="30"
        height="4"
        x="14"
        y="46"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="77"
        height="4"
        x="14"
        y="18"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="77"
        height="4"
        x="116"
        y="51"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="77"
        height="4"
        x="116"
        y="79"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="77"
        height="4"
        x="116"
        y="107"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="77"
        height="4"
        x="14"
        y="32"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="67"
        height="4"
        x="121"
        y="65"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <rect
        width="67"
        height="4"
        x="121"
        y="93"
        fill="#8990A3"
        fillOpacity="0.25"
        rx="2"
      ></rect>
      <path
        stroke="#8990A3"
        strokeOpacity="0.23"
        d="M118.5 131.5H191.5V147.5H118.5z"
      ></path>
      <path
        stroke="#8990A3"
        strokeOpacity="0.23"
        d="M14.5 65.5H87.5V147.5H14.5z"
      ></path>
      <path fill="#3456A8" d="M116 17H193V43H116z"></path>
      <path
        fill="#fff"
        d="M150.465 24.238V37h4.932c2.394 0 3.942-1.494 3.942-3.564 0-1.584-1.008-2.718-2.25-3.024 1.062-.36 1.854-1.422 1.854-2.736 0-1.98-1.404-3.438-3.888-3.438h-4.59zm2.448 5.274v-3.186h1.746c1.206 0 1.836.612 1.836 1.584 0 .972-.684 1.602-1.818 1.602h-1.764zm0 5.418v-3.366h2.052c1.242 0 1.89.702 1.89 1.71 0 1.026-.72 1.656-1.926 1.656h-2.016z"
      ></path>
      <rect
        width="205.567"
        height="163.654"
        x="0.173"
        y="0.173"
        stroke="#E1E1E1"
        strokeWidth="0.346"
        rx="5.392"
      ></rect>
    </svg>
  );
};

export default RegistrationForm;
